import React, { useMemo, useEffect, useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';

export default function ThemeRegistry({ children }) {
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: 'light',
          primary: {
            main: '#1976d2',
          },
          secondary: {
            main: '#dc004e',
          },
        },
        typography: {
          fontFamily: "Poppins, sans-serif", 
        },
       
      }),
    []
  );

  const { cache, flush } = useMemo(() => {
    const cache = createCache({ key: 'mui' });
    cache.compat = true;

    let inserted = [];
    const originalInsert = cache.insert;

    cache.insert = (...args) => {
      const serialized = args[1];
      if (!cache.inserted[serialized.name]) {
        inserted.push(serialized.name);
      }
      return originalInsert(...args);
    };

    return {
      cache,
      flush: () => {
        const prevInserted = inserted;
        inserted = [];
        return prevInserted;
      },
    };
  }, []);

  const [styles, setStyles] = useState('');

  useEffect(() => {
    const names = flush();
    if (names.length > 0) {
      const newStyles = names.map((name) => cache.inserted[name]).join('');
      setStyles(newStyles);
    }
  }, [flush]);

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {styles && <style data-emotion={`${cache.key}`} dangerouslySetInnerHTML={{ __html: styles }} />}
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
}
